import { useLayoutEffect, useRef, useState } from "react";

function useContainerWidth<T extends HTMLElement>({
  liveMeasure = true,
}: {
  liveMeasure?: boolean;
} = {}): [React.MutableRefObject<T | undefined>, number | undefined] {
  const [width, setWidth] = useState<number>();
  const ref = useRef<T>();

  useLayoutEffect(() => {
    if (ref.current) {
      const measure = () =>
        // setWidth(undefined);
        window.requestAnimationFrame(() => {
          if (ref.current) {
            const rect = ref.current.getBoundingClientRect();
            setWidth(Math.round(rect.width));
          }
        });
      measure();

      if (liveMeasure) {
        window.addEventListener("resize", measure);
        window.addEventListener("scroll", measure);

        return () => {
          window.removeEventListener("resize", measure);
          window.removeEventListener("scroll", measure);
        };
      }
    }
  }, [liveMeasure]);

  return [ref, width];
}

export default useContainerWidth;
